<script setup>
import {Menu, MenuButton, MenuItem, MenuItems} from "@headlessui/vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

const toolsNavigation = [
    {name: 'Creatures', page: '/creature', current: false, icon: ['far', 'paw-claws']},
    {name: 'Characters', page: '/character', current: false, icon: ['fad', 'users']},
    {name: 'Equipment', page: '/equipment', current: false, icon: ['far', 'sword']},
    {name: 'Merchants', page: '/merchant', current: false, icon: ['fad', 'sack']},
    {name: 'Maps', page: '/etch/editor', current: false, icon: ['far', 'map']},
]

const siteNavigation = [
    {name: 'Compendium', page: '/compendium', current: false, icon: ['fad', 'books']},
    {name: 'Search', page: '/search', current: false, icon: ['far', 'search']},
]

</script>

<template>
    <Menu as="div" class="relative ml-4 flex-shrink-0">
        <div>
            <MenuButton class="flex">
                <span class="sr-only">Open navigation menu</span>
                <FontAwesomeIcon :icon="['far', 'bars']" class="mt-1 ml-1 mr-1" size="lg" style="cursor: pointer; color: #ffffff"/>
            </MenuButton>
            <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                <MenuItems class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div>
                        <MenuItem v-for="item in toolsNavigation" :key="item.name" v-slot="{ active }" class="cursor-pointer">
                            <router-link
                                :to="item.page"
                                :class="[item.page === $route.path ? 'bg-gray-200' : '', 'block px-4 py-2 text-sm text-gray-700']"
                            >
                                <FontAwesomeIcon :icon="item.icon" class="mr-1"  size="lg" style="cursor: pointer; color: #6b7280"/>
                                <span v-html="item.name"></span>
                            </router-link>
                        </MenuItem>
                    </div>
                    <div class="py-1 border-t border-gray-300 lg:hidden">
                        <MenuItem v-for="item in siteNavigation" :key="item.name" v-slot="{ active }" class="cursor-pointer">
                            <router-link
                                :to="item.page"
                                :class="[item.page === $route.path ? 'bg-gray-200' : '', 'block px-4 py-2 text-sm text-gray-700']"
                            >
                                <FontAwesomeIcon :icon="item.icon" class="mr-1"  size="lg" style="cursor: pointer; color: #6b7280"/>
                                <span v-html="item.name"></span>
                            </router-link>
                        </MenuItem>
                    </div>
                </MenuItems>
            </transition>
        </div>
    </Menu>
</template>
